<template>
  <div class="wrapper-select-search buscador-barrios w-100 d-flex justify-content-between align-items-center ico-blue ico-left font-AR">
    <div class="ln-multiselect dropdown w-100">
      <button
        class="btn btn-secondary font-AR tracking-normal dropdown-toggle w-100 text-left p-0 d-flex align-items-center border-right border-left border-top-0 border-bottom-0 rounded-0"
        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
        @click="dropdownOpen = !dropdownOpen" aria-expanded="false">
        <div class="search-icon-box-only position-relative d-flex justify-content-center align-items-center">
          <div class="search-icon"></div>
          </div>
        <p class="mb-0 pl-1">{{ selectedBarrio.length > 0 ? selectedBarrio[0].name : 'Buscar barrio' }}</p>
      </button>
      <div class="dropdown-menu w-100 mt-0 rounded-bottom" :class="{ 'smallerHeight': searchBarriosError, show: dropdownOpen }"
        aria-labelledby="dropdownMenuButton">
        <input type="text" v-model="form.searchTerm" placeholder="Filtrar"
          class="form-control search-filter mx-auto mb-2 font-AR">
        <a class="dropdown-item full-width-item d-flex align-items-center" href="#"
          v-for="(option, index) in filteredBarrios" :key="index" @click.prevent="selectBarrio(option)">
          {{ option.name }}
        </a>
        <p v-if="searchBarriosError" class="dropdown-item">Sin resultados</p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, reactive, ref } from "vue";
export default {
  props: {
    barrios: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const form = reactive({
      searchTerm: "",
    });
    const selectedBarrio = ref([]);
    const dropdownOpen = ref(false);
    const barrios = ref(props.barrios);

    const selectBarrio = (option) => {
      debugger;
      window.open(`/servicios/barrio/${option.slug}`, '_self')
      selectedBarrio.value = option.name;
      form.value.searchTerm = option;
      dropdownOpen.value = false;
    };
    const searchBarriosError = computed(() => filteredBarrios.value.length === 0);
    const filteredBarrios = computed(() => {
      if (!form.searchTerm) {
        return props.barrios;
      }
      return props.barrios.filter(barrio => barrio.slug.includes(form.searchTerm.toLowerCase()));
    });

    return {
      barrios,
      form,
      selectedBarrio,
      barrios,
      filteredBarrios,
      selectBarrio,
      searchBarriosError,
      dropdownOpen
    };
  },
}
</script>

<style lang="scss"></style>
